// Basit şifreleme fonksiyonu (frontend için)
const ENCRYPTION_KEY = 'kafe-frontend-encryption-2024-secure';

/**
 * Basit şifreleme (frontend için)
 */
function simpleEncrypt(text: string): string {
  try {
    // Base64 + basit XOR şifreleme + timestamp
    const key = ENCRYPTION_KEY;
    const timestamp = Date.now().toString();
    const textWithTimestamp = `${timestamp}:${text}`;
    let encrypted = '';
    
    for (let i = 0; i < textWithTimestamp.length; i++) {
      const charCode = textWithTimestamp.charCodeAt(i) ^ key.charCodeAt(i % key.length);
      encrypted += String.fromCharCode(charCode);
    }
    
    return btoa(encrypted);
  } catch (error) {
    console.error('Şifreleme hatası:', error);
    return text; // Hata durumunda orijinal metni döndür
  }
}

/**
 * Basit şifre çözme (frontend için)
 */
function simpleDecrypt(encryptedText: string): string {
  try {
    const key = ENCRYPTION_KEY;
    const decrypted = atob(encryptedText);
    let text = '';
    
    for (let i = 0; i < decrypted.length; i++) {
      const charCode = decrypted.charCodeAt(i) ^ key.charCodeAt(i % key.length);
      text += String.fromCharCode(charCode);
    }
    
    // Timestamp'i çıkar
    const colonIndex = text.indexOf(':');
    if (colonIndex > 0) {
      const timestamp = parseInt(text.substring(0, colonIndex));
      const now = Date.now();
      
      // Token'ın 24 saatten eski olup olmadığını kontrol et
      if (now - timestamp > 24 * 60 * 60 * 1000) {
        console.warn('Token çok eski, temizleniyor');
        return '';
      }
      
      return text.substring(colonIndex + 1);
    }
    
    return text;
  } catch (error) {
    console.error('Şifre çözme hatası:', error);
    return encryptedText; // Hata durumunda şifrelenmiş metni döndür
  }
}

/**
 * Güvenli localStorage set
 */
export function secureSetItem(key: string, value: string): void {
  try {
    const encrypted = simpleEncrypt(value);
    localStorage.setItem(key, encrypted);
  } catch (error) {
    console.error('Güvenli kaydetme hatası:', error);
    // Fallback: normal kaydetme
    localStorage.setItem(key, value);
  }
}

/**
 * Güvenli localStorage get
 */
export function secureGetItem(key: string): string | null {
  try {
    const encrypted = localStorage.getItem(key);
    if (!encrypted) return null;
    
    return simpleDecrypt(encrypted);
  } catch (error) {
    console.error('Güvenli okuma hatası:', error);
    // Fallback: normal okuma
    return localStorage.getItem(key);
  }
}

/**
 * Güvenli localStorage remove
 */
export function secureRemoveItem(key: string): void {
  try {
    localStorage.removeItem(key);
  } catch (error) {
    console.error('Güvenli silme hatası:', error);
  }
}

/**
 * Hassas verileri temizle
 */
export function clearSensitiveData(): void {
  const sensitiveKeys = [
    'cloudinaryApiKey',
    'cloudinaryApiSecret',
    'cloudinaryCloudName'
  ];
  
  sensitiveKeys.forEach(key => {
    secureRemoveItem(key);
  });
}

/**
 * API key formatını kontrol et
 */
export function validateApiKey(apiKey: string): boolean {
  if (!apiKey || apiKey.length < 10) {
    return false;
  }
  
  const validPattern = /^[a-zA-Z0-9_-]+$/;
  return validPattern.test(apiKey);
}

/**
 * Cloudinary API key formatını kontrol et
 */
export function validateCloudinaryApiKey(apiKey: string): boolean {
  const validPattern = /^\d+$/;
  return validPattern.test(apiKey);
}

/**
 * Cloudinary API secret formatını kontrol et
 */
export function validateCloudinaryApiSecret(apiSecret: string): boolean {
  const validPattern = /^[a-zA-Z0-9_-]+$/;
  return validPattern.test(apiSecret);
}

